export const getInitials = (name: string): string =>
	name
		.split(' ')
		.slice(0, 2)
		.map((item) => item[0])
		.join('');
